import { render, staticRenderFns } from "./Customfield.vue?vue&type=template&id=b2330892&scoped=true"
import script from "./Customfield.vue?vue&type=script&lang=js"
export * from "./Customfield.vue?vue&type=script&lang=js"
import style0 from "./Customfield.vue?vue&type=style&index=0&id=b2330892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2330892",
  null
  
)

export default component.exports